/* =====================================================================================
   KI-HINWEIS (ollihess, custom)

   Setzt auf JEDES Bild, dessen ALT-Text den Marker "@ki-generiert" enthaelt, ein rundes
   "KI"-Badge; der Klick darauf oeffnet den Transparenz-Hinweis. Bilder ohne Marker bleiben
   unberuehrt -- das Badge erscheint also nie automatisch, sondern nur dort, wo der Marker
   im Admin bewusst gesetzt wurde.

   Warum ALT-Text als Schalter: Shopify hat fuer einzelne Bilder keine Metafelder, der ALT
   ist der einzige Haken pro Bild -- dasselbe Prinzip nutzt das Theme schon fuer
   Varianten-Bilder ("#Farbe_petrol") und Sprach-Bilder ("@en").
   Warum NICHT "#ki" oder "@ki" als Marker: ein "#..."-Token liest Impacts Varianten-Filter
   als Option_Wert und ein "@xx" mit genau zwei Zeichen liest unser Sprach-Filter als
   Sprachcode (beides in snippets/product-gallery.liquid) -- solche Marker wuerden das Bild
   ausblenden statt es zu kennzeichnen. Kombinieren ist erlaubt, #-Tags gehoeren nach
   hinten: "Verpackung @ki-generiert #Farbe_petrol".

   Warum clientseitig statt per Liquid pro Sektion: so gilt der Hinweis mit einer Datei fuer
   Produktgalerie, Feature-Banner, Produktkarten und jede andere Sektion, statt in einem
   Dutzend Sektionsdateien einzeln eingebaut zu werden (und ins Live-Theme sind es nur zwei
   neue Assets plus drei Zeilen in layout/theme.liquid). Nachgeladene Inhalte (Cart-Drawer,
   Quick-View, Varianten-Wechsel) deckt der MutationObserver ab.

   Texte kommen aus den Theme-Einstellungen ueber window.ohAiNotice
   (snippets/oh-ai-notice-config.liquid), Styles aus assets/oh-ai-notice.css.
   ===================================================================================== */
(function () {
  var config = window.ohAiNotice || {};
  if (config.enabled === false) return;

  var LABEL = config.label || 'KI';
  var TITLE = config.title || 'Mit KI generiert';
  var TEXT = config.text || 'Dieses Bild wurde ganz oder teilweise mithilfe künstlicher Intelligenz erstellt.';

  /* Bilder, die kein Badge bekommen: die Zoom-Ansicht (PhotoSwipe skaliert und verschiebt
     ihren Inhalt, das Badge wuerde mitwandern) und die Galerie-Thumbnails, die mit 56 px
     zu klein sind -- das grosse Bild daneben tragt den Hinweis ja schon. */
  var SKIP = '.pswp, .product-gallery__thumbnail, .page-dots';

  var dialog = null;

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  function buildDialog() {
    dialog = document.createElement('dialog');
    dialog.className = 'oh-ai-notice';
    dialog.innerHTML =
      '<div class="oh-ai-notice__card">' +
        '<div class="oh-ai-notice__head">' +
          '<p class="oh-ai-notice__title"></p>' +
          '<button type="button" class="oh-ai-notice__close" aria-label="Schließen">' +
            '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" focusable="false">' +
              '<path d="M1 1l12 12M13 1L1 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
            '</svg>' +
          '</button>' +
        '</div>' +
        '<p class="oh-ai-notice__text"></p>' +
      '</div>';

    dialog.querySelector('.oh-ai-notice__title').textContent = TITLE;
    dialog.querySelector('.oh-ai-notice__text').textContent = TEXT;
    dialog.querySelector('.oh-ai-notice__close').addEventListener('click', close);

    // Klick neben die Karte (also auf den Backdrop) schliesst den Hinweis.
    dialog.addEventListener('click', function (event) {
      if (!event.target.closest('.oh-ai-notice__card')) close();
    });

    document.body.appendChild(dialog);
    return dialog;
  }

  function open() {
    if (!dialog) buildDialog();

    // Sehr alte Browser ohne <dialog>: Text trotzdem erreichbar machen.
    if (typeof dialog.showModal !== 'function') {
      window.alert(TITLE + '\n\n' + TEXT);
      return;
    }

    // <dialog>.showModal() liegt im Top-Layer: kein Abschneiden durch die scrollende
    // Galerie (overflow) oder Karussell-Transforms, Fokusfalle und Esc kommen vom Browser.
    dialog.showModal();
  }

  function createBadge() {
    var badge = document.createElement('button');
    badge.type = 'button';
    badge.className = 'oh-ai-badge';
    badge.title = TITLE;
    badge.setAttribute('aria-haspopup', 'dialog');
    badge.innerHTML =
      '<span aria-hidden="true"></span>' +
      '<span class="sr-only"></span>';
    badge.firstChild.textContent = LABEL;
    badge.lastChild.textContent = TITLE + ' – Hinweis anzeigen';

    badge.addEventListener('click', function (event) {
      // Das Badge sitzt oft in einem Link (Produktkarte) oder auf einem klickbaren
      // Galeriebild -- der Klick darf nur den Hinweis oeffnen.
      event.preventDefault();
      event.stopPropagation();
      open();
    });

    return badge;
  }

  function mark(image) {
    if (image.getAttribute('data-oh-ai') !== null) return;

    if (image.closest(SKIP)) {
      image.setAttribute('data-oh-ai', 'skip');
      return;
    }

    // <picture> ist inline und hat keine eigene Box, in dem Fall eine Ebene hoeher ankern.
    var anchor = image.parentElement;
    if (anchor && anchor.tagName === 'PICTURE') anchor = anchor.parentElement;
    if (!anchor) return;

    image.setAttribute('data-oh-ai', 'done');
    if (anchor.querySelector(':scope > .oh-ai-badge')) return;

    // Nur ankern, wenn der Container noch keinen eigenen Bezugspunkt hat: position:relative
    // aendert den Textfluss nicht, verschiebt aber absolut positionierte Kinder -- deshalb
    // nicht anfassen, wo das Theme schon relative/absolute gesetzt hat (z. B. .feature-banner).
    if (window.getComputedStyle(anchor).position === 'static') {
      anchor.classList.add('oh-ai-anchor');
    }

    anchor.appendChild(createBadge());
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    // Gross-/Kleinschreibung im ALT ist egal ("@KI-generiert" zaehlt auch).
    var images = root.querySelectorAll('img[alt*="@ki-" i]');
    for (var i = 0; i < images.length; i++) mark(images[i]);
  }

  function init() {
    scan(document);

    // Nachgeladenes abdecken (Cart-Drawer, Quick-View, Sektionen im Theme-Editor).
    if (!window.MutationObserver) return;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        scan(document);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();